/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../../../../node_modules/@ar2/common/dist/components/fr-segment/segment.component.ngfactory";
import * as i2 from "@ar2/common/dist/components/fr-segment/segment.component";
import * as i3 from "./tabs.component";
import * as i4 from "ionic-angular/navigation/nav-controller";
import * as i5 from "@ngrx/store";
import * as i6 from "../../../services/event.service";
import * as i7 from "../../../services/action.service";
var styles_Tabs = [""];
var RenderType_Tabs = i0.ɵcrt({ encapsulation: 0, styles: styles_Tabs, data: {} });
export { RenderType_Tabs as RenderType_Tabs };
export function View_Tabs_0(_l) { return i0.ɵvid(2, [(_l()(), i0.ɵted(-1, null, ["\n"])), (_l()(), i0.ɵeld(1, 0, null, null, 2, "sg-segment", [], null, [[null, "clickEvent"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("clickEvent" === en)) {
        var pd_0 = (_co.selectTab($event) !== false);
        ad = (pd_0 && ad);
    } return ad; }, i1.View_SegmentComponent_0, i1.RenderType_SegmentComponent)), i0.ɵdid(2, 114688, null, 0, i2.SegmentComponent, [i0.Injector, i0.ElementRef, i0.Renderer2], { tabs: [0, "tabs"], isSecondary: [1, "isSecondary"], activeTab: [2, "activeTab"] }, { clickEvent: "clickEvent" }), (_l()(), i0.ɵted(-1, null, ["\n"]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.tabs; var currVal_1 = _co.secondary; var currVal_2 = _co.activeTab; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2); }, null); }
export function View_Tabs_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-tabs", [], null, null, null, View_Tabs_0, RenderType_Tabs)), i0.ɵdid(1, 49152, null, 0, i3.Tabs, [i4.NavController, i5.Store, i6.UIEventHub, i7.ActionCreator, i0.Injector], null, null)], null, null); }
var TabsNgFactory = i0.ɵccf("app-tabs", i3.Tabs, View_Tabs_Host_0, { id: "id", title: "title", childrenKeys: "childrenKeys", viewModelPath: "viewModelPath", errorMessages: "errorMessages", secondary: "secondary", tabs: "tabs", activeTab: "activeTab", showConfirm: "showConfirm", confirmDialogConfig: "confirmDialogConfig" }, {}, []);
export { TabsNgFactory as TabsNgFactory };
//# sourceMappingURL=tabs.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/widgets/tab/tabs/tabs.component.ngfactory.js
// module id = 963
// module chunks = 1